import React, { useContext } from 'react';

import { AccountResponseDTO } from '_lib/api/apiTypes.shim';

import { DialogContent } from '_lib/components/DialogContent/DialogContent';
import { AccountUserCreate } from '_lib/featureComponents/AccountUser/AccountUserCreate';
import { AccountUserUpdate } from '_lib/featureComponents/AccountUser/AccountUserUpdate';
import { AuthContext } from '_lib/featureComponents/auth/authContext';
import { DialogWrapper } from '_lib/featureComponents/DialogWrapper/DialogWrapper';

import { AsyncDialogProps, useAsyncDialog } from '_lib/hooks/useAsyncDialog';

export type AccountUserCreateUpdateDialogProps = AsyncDialogProps & {
  account?: AccountResponseDTO;
  accountUserId?: string;
};

const AccountUserCreateUpdateDialog = (props: AccountUserCreateUpdateDialogProps) => {
  const { account, accountUserId, onClose, ...dialogProps } = props;

  const { authUserCacheResource } = useContext(AuthContext);

  const cachedAuthUserQuery = authUserCacheResource.useCacheQuery();

  const handleConfirm = async () => {
    onClose({ action: 'CONFIRM' });
  };

  return (
    <DialogWrapper
      onClose={onClose}
      titleText='User'
      maxWidth='xl'
      sx={{
        '& .MuiPaper-root.MuiDialog-paper': {
          display: 'flex',
          flexGrow: 1,
          flexDirection: 'column'
        }
      }}
      {...dialogProps}>
      <DialogContent
        sx={(theme) => ({
          backgroundColor: theme.palette.background.default
        })}>
        {accountUserId ? (
          <AccountUserUpdate
            accountUserId={accountUserId}
            authUser={cachedAuthUserQuery.data}
            isFetchingFromProps={cachedAuthUserQuery.isFetching}
            onSave={handleConfirm}
          />
        ) : (
          <AccountUserCreate
            accountId={account?.id}
            callCenterId={account?.callCenterId}
            authUser={cachedAuthUserQuery.data}
            isFetchingFromProps={cachedAuthUserQuery.isFetching}
            onSave={handleConfirm}
          />
        )}
      </DialogContent>
    </DialogWrapper>
  );
};

export const useAccountUserCreateUpdateDialog = () => useAsyncDialog(AccountUserCreateUpdateDialog);
